var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.dashboard")) +
                "\n        "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content col-md-12" }, [
      !_vm.ready
        ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c(
            "section",
            { staticStyle: { "margin-top": "10px" } },
            [
              _vm.filterSessions.length === 0
                ? _c("base-not-found-data", {
                    attrs: {
                      title: _vm.$t("message.notfoundbranch"),
                      detail: _vm.$t("message.createnewbranchat")
                    }
                  })
                : _vm._l(_vm.filterSessions, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "col-sm-12 col-md-12 col-xl-5",
                        staticStyle: { "margin-bottom": "30px" }
                      },
                      [
                        !item.isInit
                          ? _c(
                              "div",
                              { staticClass: "col-12 no-padding card" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    staticStyle: {
                                      padding: "15px 15px 13px 15px"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row no-padding mb-1",
                                        staticStyle: {
                                          "margin-left": "0",
                                          "margin-right": "0"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col no-padding" },
                                          [
                                            _c("section-title", {
                                              attrs: {
                                                title: item.branchName,
                                                fontweight: "bold"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "card-text row" }, [
                                      _c("span", { staticClass: "col-4" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.pos.message.salestartedtime"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "col-8 text-right" },
                                        [_vm._v("-")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "card-text row" }, [
                                      _c("span", { staticClass: "col-4" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.pos.message.saledurationtime"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "col-8 text-right" },
                                        [_vm._v("-")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "card-text row" }, [
                                      _c("span", { staticClass: "col-4" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.pos.message.transactions"
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "col-8 text-right" },
                                        [_vm._v("-")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { "min-height": "36px" } },
                                      [
                                        !_vm.loading_.btn_new
                                          ? [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-web col-12",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.newSession(
                                                        item.branchId
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-sign-in-alt"
                                                  }),
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "apps.pos.button.newsession"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.loading_.btn_new
                                          ? [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-web col-12",
                                                  attrs: { disabled: "" }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-spinner spin"
                                                  })
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            )
                          : _c("div", { staticClass: "col-12 no-padding" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 no-padding card" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-body",
                                      staticStyle: {
                                        padding: "15px 15px 13px 15px"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "row no-padding mb-1",
                                          staticStyle: {
                                            "margin-left": "0",
                                            "margin-right": "0"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col no-padding" },
                                            [
                                              _c("section-title", {
                                                attrs: {
                                                  title: item.branchName,
                                                  fontweight: "bold"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col no-padding" },
                                            [
                                              _c("router-link-custom", {
                                                staticStyle: { float: "right" },
                                                attrs: {
                                                  to: {
                                                    name:
                                                      "PosTransactionDetail",
                                                    query: {
                                                      ps_id: item.ps_id,
                                                      ps_code: item.ps_code
                                                    }
                                                  },
                                                  text: item.ps_code,
                                                  status: {
                                                    text: _vm.getStatusText(
                                                      item.status
                                                    ),
                                                    color: _vm.getStatusColor(
                                                      item.status
                                                    ),
                                                    type: "icon"
                                                  },
                                                  to_appid: 1,
                                                  current_appid: 1
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "card-text row" },
                                        [
                                          _c("span", { staticClass: "col-4" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.pos.message.salestartedtime"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "col-8 text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDateTime(
                                                    item.started_at
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "card-text row" },
                                        [
                                          _c("span", { staticClass: "col-4" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.pos.message.saledurationtime"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "col-8 text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getDurationFriendlyBySeconds(
                                                    (_vm
                                                      .moment(_vm.now)
                                                      .format("x") -
                                                      _vm
                                                        .moment(item.started_at)
                                                        .format("x")) /
                                                      1000,
                                                    _vm.$t
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "card-text row" },
                                        [
                                          _c("span", { staticClass: "col-4" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.pos.message.transactions"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "col-8 text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.transactionInfo
                                                    ? item.transactionInfo.count
                                                    : 0
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.stockBills.length > 0 &&
                                      _vm.stockBills.some(function(bill) {
                                        return bill.ps_id === item.ps_id
                                      })
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "card-text text-center row",
                                              staticStyle: {
                                                padding: "15px 0px 12px 0",
                                                margin: "0",
                                                background:
                                                  "rgba(203,203,203,.2)"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "col-12 text-danger"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.pos.message.warningtosyncdata",
                                                        {
                                                          number:
                                                            _vm.stockBills
                                                              .length
                                                        }
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "col-12",
                                                  staticStyle: {
                                                    "font-size": "11px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "apps.pos.message.clicksyncbuttonbelow"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "col-12 mt-3" },
                                                [
                                                  [
                                                    !_vm.$store.state.app
                                                      .loading
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-sm btn-primary",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.insertBillsInStock(
                                                                  _vm.stockBills,
                                                                  item.ps_id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-sync-alt"
                                                            }),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "apps.pos.button.sync"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-sm btn-primary",
                                                            attrs: {
                                                              disabled: true
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-sync-alt spin"
                                                            }),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "apps.pos.button.sync"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                  ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "col-12 mt-3" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "https://www.treesoft.io/th/manual/pos#dashboard",
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "button.learnmore"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-external-link-alt"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "form-row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-6" },
                                                [
                                                  !_vm.loading_.btn_resume
                                                    ? [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-light col-12",
                                                            attrs: {
                                                              disabled:
                                                                _vm.disabled_
                                                                  .btn_resume
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.resumeSession(
                                                                  item.ps_id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-sign-in-alt"
                                                            }),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "apps.pos.button.resumesession"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.loading_.btn_resume
                                                    ? [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-light col-12",
                                                            attrs: {
                                                              disabled: ""
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-spinner spin"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-6" },
                                                [
                                                  !_vm.loading_.btn_close
                                                    ? [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-web col-12",
                                                            attrs: {
                                                              disabled:
                                                                _vm.disabled_
                                                                  .btn_close
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeSession(
                                                                  item.branch_id,
                                                                  item.ps_id,
                                                                  item.ps_code
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-check"
                                                            }),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "apps.pos.button.closesession"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.loading_.btn_close
                                                    ? [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-web col-12",
                                                            attrs: {
                                                              disabled: ""
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-spinner spin"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                    ]
                                  )
                                ]
                              )
                            ])
                      ]
                    )
                  })
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f449d9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f449d9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/All.vue
// module id = null
// module chunks = 